export default "__VITE_ASSET__BJIwLy4L__"